import React from "react";
import TextInput from "./TextInput";

const PasswordInput = ({ id = "password", label = "Palavra Passe", value, errorText = null, onChange, disabled = false, mt = 0, mb = 0 }) => {

    return (
        <TextInput
            id={id}
            name={id}
            label={label}
            type="password"
            onChange={onChange}
            errorText={errorText}
            value={value}
            disabled={disabled}
            mt={mt}
            mb={mb}
        />
    );
};

export default PasswordInput;
